<template>
  <v-col>
    <v-row>
      <v-col cols="12">
        <div class="d-flex">
          <div class="col-checkbox px-2">
            <v-simple-checkbox
              v-model="item"
              :ripple="false"
            ></v-simple-checkbox>
          </div>
          <div class="col-product-name text-bold px-2">
            Sản phẩm
          </div>
          <div class="col-product-code text-bold">
            Mã sản phẩm
          </div>
          <div class="col-product-type text-bold">
            Loại
          </div>
          <div class="col-count-sku text-bold text-center">
            Số SKU
          </div>
          <div class="col-status text-bold">
            Trạng thái
          </div>
          <div class="col-update-time text-bold text-center">
            Cập nhật
          </div>
          <div class="col-action text-bold text-center">
            Thao tác
          </div>
        </div>
      </v-col>
      <v-col cols="12" v-if="!data.length">
        <p v-if="isLoading" class="text-center">Đang tải dữ liệu....</p>
        <p v-if="!isLoading" class="text-center">Không có dữ liệu</p>
      </v-col>
      <template v-if="data.length">
        <v-col cols="12" v-for="(groupProduct, indexGR) in data" :key="'gr-' + indexGR">
          <div class="box-title-cate mb-3">
            <span v-for="(itemCategory, indexC) in groupProduct.fullLevelName" :key="'gr-' + indexGR + 'c' + indexC" class="box-group-cate">
              <span class="tail-cate" :style="{ backgroundImage: 'url(' +require('@/assets/tail-category.png') + ')' }">&nbsp;</span> 
              <span class="body-cate" :style="{ backgroundImage: 'url(' +require('@/assets/body-category.png') + ')' }">{{ itemCategory }}</span> 
              <span class="head-cate" :style="{ backgroundImage: 'url(' +require('@/assets/head-category.png') + ')' }">&nbsp;</span>
            </span>
          </div>
          <div class="item-product mb-2 pt-4" v-for="(product, itemP) in groupProduct.products" :key="'gr-' + indexGR + 'p' + itemP">
            <div class="d-flex product-info">
              <div class="col-checkbox px-2">
                <v-simple-checkbox
                  :ripple="false"
                ></v-simple-checkbox>
              </div>
              <div class="col-product-name px-2">
                {{ product.name }}
              </div>
              <div class="col-product-code">
                {{ product.code }}
              </div>
              <div class="col-product-type">
                <span v-if="product.type === productTypeDuo">Khóa học</span>
                <span v-if="product.type === productTypeTutor">Gia sư</span>
                <span v-if="product.type === productTypeCombo">Combo</span>
                <span v-if="product.type === productTypeArtifact">Hiện vật</span>
              </div>
              <div class="col-count-sku text-center">
                {{ product.numOfSku }}
              </div>
              <div class="col-status">
                {{ product.status == 'active' ? 'Hoạt động' : 'Không hoạt động' }}
              </div>
              <div class="col-update-time text-center">
                {{ formatDateDot(product.updatedAt) }}
              </div>
              <div class="col-action text-center">
                <a class="link-edit" target="_blank" :href="`/products/${product.id}`">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-pencil
                      </v-icon>
                    </template>
                    <span>Chỉnh sửa</span>
                  </v-tooltip>
                </a>
                <!-- <span class="ml-3 btn">
                  <v-icon>
                    mdi-close-circle-outline
                  </v-icon>
                </span> -->
              </div>
            </div>
            <div class="product-skus">
              <DuoSkuInList :productAttributes="productAttributes" v-if="product.type == productTypeDuo" :product="product" />
              <ArtifactSkuInList :productAttributes="productAttributes" v-if="product.type == productTypeArtifact" :product="product" />
              <TutorSkuInList :curriculumsObj="curriculumsObj" :productAttributes="productAttributes" v-if="product.type == productTypeTutor" :product="product" />
              <ComboSkuInList :productAttributes="productAttributes" v-if="product.type == productTypeCombo" :product="product" />
            </div>
          </div>
        </v-col>
      </template>
      
    </v-row>
  </v-col>
</template>

<script>
import {
  productTypeDuo,
  productTypeTutor,
  productTypeCombo,
  productTypeArtifact,
} from '../../../helpers/constants';

import RepositoryFactory from '@/repositories/RepositoryFactory';
const ProductRepository = RepositoryFactory.get('product');

import TutorSkuInList from './TutorSkuInList.vue';
import DuoSkuInList from './DuoSkuInList.vue';
import ArtifactSkuInList from './ArtifactSkuInList.vue';
import ComboSkuInList from './ComboSkuInList.vue';

export default {
  name: 'list-product',
  components: {
    TutorSkuInList,
    DuoSkuInList,
    ComboSkuInList,
    ArtifactSkuInList,
  },
  props:{
    data: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: () => false,
    },
    productAttributes: {
      type: Object,
      default: () => {},
    }
  },
  data() {
    return {
      tab: 0,
      item: null,
      productTypeDuo,
      productTypeTutor,
      productTypeCombo,
      productTypeArtifact,
      curriculumsObj: {},
    };
  },
  computed: {
  },
  async created() {
    this.getCurriculumAttributes();
  },
  beforeDestroy() {
  },
  methods: {
    // editProduct(product) {
    //   this.$router.push(`/products/${product.id}`)
    // },
    async getCurriculumAttributes() {
      const res = await ProductRepository.getCurriculumAttributes();
      res.data.forEach((item) => {
        this.curriculumsObj[item.id] = item;
      })
    },
  },
  watch: {
    // currentPage: {
    //   handler() {
    //     this.addHashToLocation( {...this.filterForm, page: this.currentPage });
    //     this.getList();
    //   }
    // },
  }
};
</script>
<style scoped lang="scss">
.col-checkbox {
  width: 5%;
}
.col-product-name {
  width: 25%;
}
.col-product-code {
  width: 20%;
}
.col-product-type {
  width: 10%;
}
.col-count-sku {
  width: 10%;
}
.col-status {
  width: 10%;
}
.col-update-time {
  width: 10%;
}
.col-action {
  width: 10%;
}
.text-bold {
  font-weight: bold;
}
.box-title-cate {
  display: flex;
  color: #fff;
  font-weight: bold;

  .box-group-cate {
    display: flex;
    margin-left: -4px;
  }

  .tail-cate {
    width: 9px;
    height: 21px;
    display: inline-block;
  }
  .body-cate {
    height: 21px;
    display: inline-block;
    background-repeat: repeat-x;
    min-width: 80px;
    padding-left: 12px;
  }
  .head-cate {
    width: 10px;
    height: 21px;
    display: inline-block;
  }
}
.item-product {
  background: #FAFBFF;
  border-radius: 10px;
  box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.25);

  .product-info {
    border-bottom: 1px solid #F1F1F1;
  }
  .btn {
    cursor: pointer;
  }
}
.link-edit {
  text-decoration: none !important;
}
</style>
